import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
  padding: 20px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 16px;
    gap: 16px;
  }
`;

export const AppCard = styled.div`
  position: relative; /* Adicionado para suportar o overlay */
  width: 100%;
  min-height: 160px;
  
  background: linear-gradient(135deg, #ffffff 0%, #faf9ff 100%);
  border: 1px solid rgba(116, 76, 180, 0.1);
  border-radius: 16px;
  padding: 20px;

  box-shadow: 0 4px 20px rgba(116, 76, 180, 0.08), 0 1px 3px rgba(0, 0, 0, 0.05);
  transition: all 300ms ease;
  cursor: pointer;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 30px rgba(116, 76, 180, 0.15), 0 4px 12px rgba(0, 0, 0, 0.1);
    border-color: rgba(116, 76, 180, 0.2);
  }

  @media (max-width: 768px) {
    min-height: 140px;
    padding: 16px;
  }
`;

export const CardContent = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  height: 100%;
  
  @media (max-width: 768px) {
    gap: 12px;
  }
`;

export const ImageContainer = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  
  @media (max-width: 768px) {
    width: 50px;
    height: 50px;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 6px;
  flex: 1;
  min-width: 0;
`;

export const Title = styled.span`
  font-weight: 600;
  font-size: 20px;
  color: #2d1b69;
  margin-bottom: 4px;
`;

export const Content = styled.span`
  font-size: 14px;
  color: #6b7280;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

export const ArrowContainer = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #744cb4 0%, #9b59b6 100%);
  cursor: pointer;
  transition: all 200ms ease;
  
  &:hover {
    transform: scale(1.1);
    box-shadow: 0 4px 12px rgba(116, 76, 180, 0.3);
  }
  
  @media (max-width: 768px) {
    width: 36px;
    height: 36px;
  }
`;



export const ArrowIcon = styled.span`
  color: white;
  font-size: 18px;
  font-weight: bold;
  transform: translateX(1px);
  
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;


export const StyledLink = styled(Link)`
  text-decoration: none;
  color: inherit;
  display: block;
  width: 100%;
  height: 100%;
`;


export const CardParameter = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(10px);
  border-radius: 16px;
  border: 2px solid rgba(116, 76, 180, 0.2);
  box-shadow: 0 8px 32px rgba(116, 76, 180, 0.2);
  
  display: flex;
  padding: 20px;
  gap: 16px;
  
  z-index: 10;
  cursor: pointer;
  
  /* Container interno para o formulário */
  > div {
    display: flex;
    width: 100%;
    height: 100%;
    cursor: default;
  }
  
  /* Sobrescrever a estrutura do Forms */
  .FormRoot {
    display: flex;
    width: 100%;
    height: 100%;
    gap: 16px;
  }
  
  .FormField {
    flex: 1 !important;
    display: flex !important;
    flex-direction: column !important;
    gap: 12px !important;
    max-height: 100% !important;
    overflow-y: auto !important;
    padding-right: 8px !important;
    margin: 0 !important;
    
    /* Estilo da scrollbar */
    &::-webkit-scrollbar {
      width: 6px;
    }
    
    &::-webkit-scrollbar-track {
      background: rgba(116, 76, 180, 0.1);
      border-radius: 3px;
    }
    
    &::-webkit-scrollbar-thumb {
      background: rgba(116, 76, 180, 0.3);
      border-radius: 3px;
      
      &:hover {
        background: rgba(116, 76, 180, 0.5);
      }
    }
  }
  
  /* Container dos botões do Forms */
  .FormRoot > div:last-child {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    flex-shrink: 0;
    width: auto;
    margin: 0;
  }
  
  @media (max-width: 768px) {
    padding: 16px;
    gap: 12px;
  }
`;

export const ParameterButtonContainer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  flex-shrink: 0;
  width: auto;
  min-width: 120px;
`;

